import styled from "styled-components";
import { colorsPalettes, rgba } from "@similarweb/styles";

// Taken from node_modules/@similarweb/styles/src/z-index.scss:26
const CURRENT_MAX_Z_INDEX = 1021;

export const StyledOverlayContainer = styled.div`
    position: absolute;
`;

export const StyledRightBarFixedContainer = styled.div<{ isSideBarOpen: boolean }>`
    background-color: ${colorsPalettes.bluegrey[100]};
    height: 100vh;
    width: 548px;
    right: 0;
    top: 0;
    pointer-events: ${({ isSideBarOpen }) => (isSideBarOpen ? "all" : "none")};
    position: fixed;
    z-index: ${CURRENT_MAX_Z_INDEX + 1};
    box-shadow: 0 4px 21px 0 ${rgba(colorsPalettes.black["0"], 0.35)};
    transform: translateX(${({ isSideBarOpen }) => (isSideBarOpen ? "0" : "100%")});
    transition: 350ms linear all;
`;
